import React from "react";
import {
  Card,
  CardHeader,
  CardContent,
  Grid,
  Box,
  Typography,
} from "@mui/material";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Cell,
} from "recharts";
import useCourseModalityHook from "../hooks/CourseModalityHook";

const courseColors = {
  CI: "#00FF00", // Green
  HI: "#8B0000", // Dark Red
  OC: "#87CEEB", // Sky Blue
  OL: "#DAA520", // Golden Rod
};

const modalityLabels = {
  CI: "At High School with College Instructor",
  HI: "At High School with HS Instructor",
  OL: "Online",
  OC: "On College Campus",
};

const CourseModality = ({ schoolId }) => {
  const { data, loading, error } = useCourseModalityHook(schoolId);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error loading data</div>;
  }

  // Log the data to ensure it's being fetched correctly
  //console.log("Data:", data);

  // Generate an array of random colors for each course modality
  const modalities = ["CI", "HI", "OC", "OL"];

  return (
    <Card>
      <CardHeader
        title="Course Modality"
        sx={{ backgroundColor: "#AC1A2F", color: "white" }}
      />
      <CardContent>
        {/* Legend/Key Section */}
        <Box sx={{ mb: 3, p: 2, backgroundColor: "#f5f5f5", borderRadius: 1 }}>
          <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
            Course Modality Key:
          </Typography>
          <Grid container spacing={2}>
            {Object.entries(modalityLabels).map(([key, label]) => (
              <Grid item xs={12} sm={6} key={key}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Box
                    sx={{
                      width: 16,
                      height: 16,
                      backgroundColor: courseColors[key],
                      borderRadius: 1,
                      border: "1px solid #ccc",
                    }}
                  />
                  <Typography variant="body2">
                    <strong>{key}:</strong> {label}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>

        <ResponsiveContainer width="100%" height={400}>
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="Year" />
            <YAxis tickFormatter={(value) => `${value * 100}%`} />
            <Tooltip formatter={(value) => `${(value * 100).toFixed(2)}%`} />
            {modalities.map((modality, index) => (
              <Bar
                key={modality}
                dataKey={modality}
                fill={courseColors[modality]}
              >
                {data.map((entry, index) => (
                  <Cell
                    key={`cell-${index}-${modality}`}
                    fill={courseColors[modality]}
                  />
                ))}
              </Bar>
            ))}
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};

export default CourseModality;
